// extracted by mini-css-extract-plugin
export default {"authheading":"IssuanceAuthorization_authheading__jTucW"};